export default __webpack_public_path__ + "static/media/Section2Diagram2.32be38cf.png";